var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThunderFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6531 4.4354H8.94203L12.2791 0.21899C12.3482 0.12971 12.2858 0 12.173 0H5.71276C5.6656 0 5.62011 0.0252681 5.59653 0.0673816L1.23188 7.6057C1.17966 7.69498 1.24368 7.80785 1.34812 7.80785H4.28596L2.77998 13.8318C2.74797 13.9632 2.90632 14.0558 3.00402 13.9615L12.7457 4.66618C12.8333 4.58364 12.7744 4.4354 12.6531 4.4354Z",
    fill: "var(--white)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderFilled);
export default __webpack_public_path__ + "static/media/thunderFilled.55336ee5122a26a0f6fcd1213b9243f2.svg";
export { ForwardRef as ReactComponent };